// @ts-nocheck
import { Percent, CurrencyUSD, Time, GraphQLDecimal } from '@/graphql/scalars';
import * as Types from '../../../../types/schema';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SalesforceFormObjectsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;
export type SalesforceFormObjectsQuery = {
  __typename?: 'Query';
  salesforceObjects: Array<{
    __typename?: 'SalesforceObject';
    name: string;
    label: string;
    custom: boolean;
    createable: boolean;
  }>;
};
export type SalesforceObjectDescriptionQueryVariables = Types.Exact<{
  object: Types.Scalars['String']['input'];
}>;
export type SalesforceObjectDescriptionQuery = {
  __typename?: 'Query';
  salesforceObjectDescription: {
    __typename?: 'SalesforceObjectDescription';
    name: string;
    label: string;
    custom: boolean;
    createable: boolean;
    fields: Array<{
      __typename?: 'SalesforceField';
      name: string;
      label: string;
      type: string;
      custom: boolean;
      createable: boolean;
      nillable: boolean;
      calculated: boolean;
      autoNumber: boolean;
      defaultedOnCreate: boolean;
      length: number;
      inlineHelpText: string;
      referenceTo: Array<string>;
      picklistValues: Array<{
        __typename?: 'SalesforcePicklistValue';
        label: string;
        value: string;
        active: boolean;
      }>;
    }>;
  };
};
export type SalesforceLayoutsQueryVariables = Types.Exact<{
  object: Types.Scalars['String']['input'];
}>;
export type SalesforceLayoutsQuery = {
  __typename?: 'Query';
  salesforceLayouts: Array<{
    __typename?: 'SalesforceLayout';
    id: string;
    label: string;
    sections: Array<{
      __typename?: 'SalesforceLayoutSection';
      id: string;
      label: string;
      fieldApiNames: Array<string>;
    }>;
  }>;
};
export const Operations = {
  Query: {
    SalesforceFormObjects: 'SalesforceFormObjects' as const,
    SalesforceObjectDescription: 'SalesforceObjectDescription' as const,
    SalesforceLayouts: 'SalesforceLayouts' as const
  }
};

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy
    }
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options
  };
}
export const SalesforceFormObjectsDocument = gql`
    query SalesforceFormObjects {
  salesforceObjects {
    name
    label
    custom
    createable
  }
}
    `;

/**
 * __useSalesforceFormObjectsQuery__
 *
 * To run a query within a React component, call `useSalesforceFormObjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesforceFormObjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesforceFormObjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSalesforceFormObjectsQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useQuery(SalesforceFormObjectsDocument, withFetchPolicyContext(options));
}
export function useSalesforceFormObjectsLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useLazyQuery(SalesforceFormObjectsDocument, withFetchPolicyContext({
    ...options,
    isLazy: true
  }));
}
export function useSalesforceFormObjectsSuspenseQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useSuspenseQuery(SalesforceFormObjectsDocument, withFetchPolicyContext(options));
}
export type SalesforceFormObjectsQueryHookResult = ReturnType<typeof useSalesforceFormObjectsQuery>;
export type SalesforceFormObjectsLazyQueryHookResult = ReturnType<typeof useSalesforceFormObjectsLazyQuery>;
export type SalesforceFormObjectsSuspenseQueryHookResult = ReturnType<typeof useSalesforceFormObjectsSuspenseQuery>;
export type SalesforceFormObjectsQueryResult = Apollo.QueryResult<SalesforceFormObjectsQuery, SalesforceFormObjectsQueryVariables>;
export const SalesforceObjectDescriptionDocument = gql`
    query SalesforceObjectDescription($object: String!) {
  salesforceObjectDescription(object: $object) {
    name
    label
    custom
    createable
    fields {
      name
      label
      type
      custom
      createable
      nillable
      calculated
      autoNumber
      defaultedOnCreate
      length
      inlineHelpText
      referenceTo
      picklistValues {
        label
        value
        active
      }
    }
  }
}
    `;

/**
 * __useSalesforceObjectDescriptionQuery__
 *
 * To run a query within a React component, call `useSalesforceObjectDescriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesforceObjectDescriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesforceObjectDescriptionQuery({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useSalesforceObjectDescriptionQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useQuery(SalesforceObjectDescriptionDocument, withFetchPolicyContext(options));
}
export function useSalesforceObjectDescriptionLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useLazyQuery(SalesforceObjectDescriptionDocument, withFetchPolicyContext({
    ...options,
    isLazy: true
  }));
}
export function useSalesforceObjectDescriptionSuspenseQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useSuspenseQuery(SalesforceObjectDescriptionDocument, withFetchPolicyContext(options));
}
export type SalesforceObjectDescriptionQueryHookResult = ReturnType<typeof useSalesforceObjectDescriptionQuery>;
export type SalesforceObjectDescriptionLazyQueryHookResult = ReturnType<typeof useSalesforceObjectDescriptionLazyQuery>;
export type SalesforceObjectDescriptionSuspenseQueryHookResult = ReturnType<typeof useSalesforceObjectDescriptionSuspenseQuery>;
export type SalesforceObjectDescriptionQueryResult = Apollo.QueryResult<SalesforceObjectDescriptionQuery, SalesforceObjectDescriptionQueryVariables>;
export const SalesforceLayoutsDocument = gql`
    query SalesforceLayouts($object: String!) {
  salesforceLayouts(object: $object) {
    id
    label
    sections {
      id
      label
      fieldApiNames
    }
  }
}
    `;

/**
 * __useSalesforceLayoutsQuery__
 *
 * To run a query within a React component, call `useSalesforceLayoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesforceLayoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesforceLayoutsQuery({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useSalesforceLayoutsQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useQuery(SalesforceLayoutsDocument, withFetchPolicyContext(options));
}
export function useSalesforceLayoutsLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useLazyQuery(SalesforceLayoutsDocument, withFetchPolicyContext({
    ...options,
    isLazy: true
  }));
}
export function useSalesforceLayoutsSuspenseQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useSuspenseQuery(SalesforceLayoutsDocument, withFetchPolicyContext(options));
}
export type SalesforceLayoutsQueryHookResult = ReturnType<typeof useSalesforceLayoutsQuery>;
export type SalesforceLayoutsLazyQueryHookResult = ReturnType<typeof useSalesforceLayoutsLazyQuery>;
export type SalesforceLayoutsSuspenseQueryHookResult = ReturnType<typeof useSalesforceLayoutsSuspenseQuery>;
export type SalesforceLayoutsQueryResult = Apollo.QueryResult<SalesforceLayoutsQuery, SalesforceLayoutsQueryVariables>;